import React, { useEffect, useRef } from "react";

import Earth from "../objects/Earth";

import Sun from "../objects/Sun";

import CSS2DSetup from "./CSS2DSetup";
import ObjectSetup from "./ObjectSetup";
import { CameraType, SpaceObjectType } from "@graphic/types";

import SkyBox from "./SkyBox";
import CameraSetup from "./CameraSetup";
import ControlSetup from "./ControlSetup";

import { QueryStatus } from "react-query";
import TimeSetup from "./TimeSetup";
import { Stats } from "@react-three/drei";
import { RADIUS } from "@graphic/constants";

type SceneProps = {
  objectData?: SpaceObjectType[];
  map?: string;
  bump?: string;
  clouds?: string;
  status?: QueryStatus;
  cameraType: CameraType;
  defaultLabel: string;
};

function Scene({
  objectData,
  map,
  bump,
  clouds,
  status,
  cameraType,
  defaultLabel
}: SceneProps): React.ReactElement {
  const earthRef = useRef<THREE.Object3D<THREE.Object3DEventMap> | null>(null);

  return (
    <>
      <ambientLight intensity={0.6} />

      <Sun />
      <Earth ref={earthRef} map={map} bump={bump} clouds={clouds} />
      {status === "success" && objectData && (
        <ObjectSetup data={objectData} earthRef={earthRef} defaultLabel={defaultLabel}/>
      )}
      {/* <SkyBox /> */}

      <CameraSetup type={cameraType} />
      <ControlSetup cameraType={cameraType} />
      <CSS2DSetup />
      <TimeSetup />

      {process.env.NODE_ENV === "development" && (
        <>
          <axesHelper args={[RADIUS * 2]} />
          <Stats />
        </>
      )}
    </>
  );
}

export default Scene;
